module.exports = __webpack_public_path__ + "static/media/oborudovanie_dlya_pp.c796ecc3.pdf";